import { QueryKey } from "@tanstack/react-query";

export const clubAsPublicQueryKeys = {
  all: () => ["clubAsPublic"] as QueryKey,
  propertiesSettings: () =>
    [...clubAsPublicQueryKeys.all(), "propertiesSettings"] as QueryKey,
};
